import { createFileRoute } from '@tanstack/react-router';

import Dashboard from '@/ui/pages/Dashboard/Dashboard';
import { dashboardSearchSchema } from '@/ui/pages/Dashboard/dashboardSearch';

export const Route = createFileRoute('/_dashboard/dashboard')({
  // HS-1501: scope and period live in the URL; every field falls back rather than throwing.
  validateSearch: dashboardSearchSchema,
  component: Dashboard,
});
